module.exports = __webpack_public_path__ + "3a207fe7ae037270822e2a54b8225455.svg";